/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { Button, Label } from 'reactstrap';
import { useField, useFormikContext, getIn } from 'formik';
import { BsFolder2Open } from 'react-icons/bs';
import { HiOutlineExternalLink } from 'react-icons/hi';
import { RiCloseLine } from 'react-icons/ri';

const EditUploadWrapper = ({
  fileName = '',
  label = '',
  handleCancel = () => {},
  required = false,
  isLinkPath = false,
  cancelDisabled = false,
  ...props
}) => {
  const [field, meta] = useField(props?.name);
  const { submitCount, errors, touched } = useFormikContext() || {};
  const isTouched = getIn(touched, props?.name) || meta?.touched;
  const errorMsg = getIn(errors, props?.name) || meta?.error;
  const shouldShowError =
    (Boolean(isTouched) || Boolean(submitCount && submitCount > 0)) &&
    errorMsg;

  return (
    <>
      <Label className="mb-2">
        {label}
        {required && <span className="text-danger ms-1">*</span>}
      </Label>
      <div className="edit-upload-wrap mb-3 position-relative">
        <BsFolder2Open
          color="#218CF2"
          size={24}
          className="file-icon position-absolute top-50 translate-middle"
        />
        <span className="text-black4a4 ms-1 file-name f-14" title={fileName}>
          {fileName}
        </span>
        {isLinkPath && (
          <a href={fileName} target="_blank" className="text-priamry open-link">
            {' '}
            <HiOutlineExternalLink size={18} />
          </a>
        )}
        <Button
          color="link"
          onClick={handleCancel}
          disabled={cancelDisabled}
          className="text-decoration-none p-0 text-dark-525 cancel-btn position-absolute top-50 translate-middle"
        >
          <RiCloseLine size={22} />
        </Button>
      </div>
      {shouldShowError ? (
        <div className="text-danger f-12">{errorMsg}</div>
      ) : null}
    </>
  );
};

export default EditUploadWrapper;
